import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/reviews_analytics_event.py
export const REVIEWS_ANALYTICS_ACTIONS = {
  CREATED_REVIEW_PROCESS: {
    module: ANALYTICS_MODULE.REVIEWS,
    action: 'created_review_process',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_REVIEW_PROCESS: {
    module: ANALYTICS_MODULE.REVIEWS,
    action: 'updated_review_process',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SET_REVIEW_PROCESS: {
    module: ANALYTICS_MODULE.REVIEWS,
    action: 'set_review_process',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_MODAL_SEND_FOR_REVIEW: {
    module: ANALYTICS_MODULE.REVIEWS,
    action: 'opened_modal_send_for_review',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  BEGAN_REVIEW_PROCESS_EXECUTION: {
    module: ANALYTICS_MODULE.REVIEWS,
    action: 'began_review_process',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COMPLETED_REVIEW_PROCESS_EXECUTION: {
    module: ANALYTICS_MODULE.REVIEWS,
    action: 'completed_review_process',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REVERTED_REVIEW_PROCESS_EXECUTION: {
    module: ANALYTICS_MODULE.REVIEWS,
    action: 'reverted_review_process',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
